// Helper function to create workout structures
function createWorkout(config) {
  const { name, sets, roundDuration, restDuration, comboTimeFactors } = config;
  const phases = [];

  // Optional: Add a preparation phase
  phases.push({
    name: "Preparation",
    duration: 10,
    components: [{ name: "restMode" }],
  });

  for (let i = 0; i < sets; i++) {
    for (let j = 0; j < 3; j++) {
      // 3 rounds per set
      // The time per punch is determined by the factor.
      // The total combo time will be calculated in the game engine
      // based on the actual combo length.
      const comboTimeFactor = comboTimeFactors[j];

      phases.push({
        name: `${i + 1} - ${j + 1}`,
        duration: roundDuration,
        components: [{ name: "comboMode", comboTimeFactor: comboTimeFactor }],
      });

      // Add rest period after each round.
      // Do not add rest after the very last round of the workout.
      if (i < sets - 1 || j < 2) {
        phases.push({
          name: "Rest",
          duration: restDuration,
          components: [{ name: "restMode" }],
        });
      }
    }
  }

  return { name, phases };
}

const basicWorkoutConfig = {
  name: "Basic",
  sets: 4,
  roundDuration: 60,
  restDuration: 15,
  comboTimeFactors: [0.6, 0.5, 0.4],
};

const advancedWorkoutConfig = {
  name: "Advanced",
  sets: 5,
  roundDuration: 120,
  restDuration: 20,
  comboTimeFactors: [0.4, 0.4, 0.4],
};

const proWorkoutConfig = {
  name: "Pro",
  sets: 6,
  roundDuration: 180,
  restDuration: 20,
  comboTimeFactors: [0.3, 0.3, 0.3],
};

export const gameModes = {
  basic: createWorkout(basicWorkoutConfig),
  advanced: createWorkout(advancedWorkoutConfig),
  pro: createWorkout(proWorkoutConfig),
  /*training: {
    name: "Training",
    phases: [
      {
        name: "Testing",
        duration: 300,
        components: [{ name: "restMode", duration: 300 }],
      },
    ],
  },
  combo: {
    name: "1,2,3",
    phases: [
      { name: "Preparation", duration: 2, components: [{ name: "restMode" }] },
      {
        name: "Round 1",
        duration: 60,
        components: [{ name: "comboMode", comboTimeLimit: 4 }],
      },
      {
        name: "Rest",
        duration: 10,
        components: [{ name: "restMode" }],
      },
      {
        name: "Round 2",
        duration: 60,
        components: [{ name: "comboMode", comboTimeLimit: 1 }],
      },
      {
        name: "Rest",
        duration: 10,
        components: [{ name: "restMode" }],
      },
      {
        name: "Round 3",
        duration: 60,
        components: [{ name: "comboMode", comboTimeLimit: 2 }],
      },
    ],
  },*/
};
